<script>
    import { fade } from 'svelte/transition';

    import { busyState } from '../store/busy';

    import { BarLoader } from 'svelte-loading-spinners';

    let isActive = true;

    busyState.subscribe((busy) => {
        isActive = busy;
    });

</script>

{#if isActive}
    <div
        transition:fade={{ delay: 200 }}
        class="overlay overlay--spinner overlay--full"
    >
        <div class="spin-wrap">
            <BarLoader />
        </div>
    </div>
{/if}

<style>
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(2px);
        z-index: 10;

        display: flex;
        align-items: center;
        justify-content: center;
    }

    .overlay--spinner {
        text-align: center;
    }

    .spin-wrap {
        display: inline-block;
    }

</style>
